import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'

const Vision = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const [missionWidget, setMissionWidget] = useState()
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [missionData, setMissionData] = useState([])

  const apiUrl = apiBaseUrl+`aboutpage`;

  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setMissionWidget(res.data.missionwidget)
      setMissionData(res.data.missionparentwidget)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  return (
    <>
    <Header/>

    { loading && (<Loader />)}

    <div id="vision" className="container vertical-gap"><hr /></div>

    <section className="section-content-block">
      <div className="container">
          <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                  <div className="about-us-intro">
                    <p className="blue">{missionWidget?.name}</p>
                    <h2 className="heading">{missionWidget?.heading}</h2>
                    <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{missionWidget?.description}</p>
                  </div>                            
              </div> 
    
          </div>

          <div className="row">
              {missionData.map((item, index) => {
                return (            
                  <div key={index} className="col-lg-6 col-md-6 col-sm-12 text-center">                       
                      <div className="Products">
                        <img src={`${siteUrl}${item?.image}`} alt={item?.name} />
                        <h4 className="heading1">{item?.name}: {item?.heading}</h4>
                        <p>{item?.description}</p>
                      </div>                            
                  </div> 
                );
            })}
          </div>
      </div> 
    </section>
    
    <Footer/>
    </>
  )
}

export default Vision